import { localize as l } from '../../libs/Localization';

const TermsAndConditions = ({ signUp = true }: { signUp?: boolean }) => {
	return (
		<div className='ml-4 my-2 mr-2 text-gray-600'>
			{signUp ? l['By signing up I agree to the'] : l['By continuing I agree to the']}{' '}
			<a href='https://mussila.com/privacy/' className='underline hover:decoration-blue-400'>
				{l['privacy policy']}
			</a>{' '}
			{l['and']}{' '}
			<a href='https://mussila.com/terms/' className='underline hover:decoration-blue-400'>
				{l['terms of service']}
			</a>
		</div>
	);
};

export default TermsAndConditions;
